import { defineStore } from 'pinia';
import api from '@/services/api';

export const useEstadoSolicitudStore = defineStore('estadoSolicitudStore', {
  state: () => ({
    estadoSolicitudList: [],
    page: 1,
  }),
  actions: {
    async findAllEstadoSolicitudHTTP() {
      const result = await api.get('/estado-solicitud', {
        params: { page: +this.page, sortBy: 'Descripcion', sort: 'asc', Activo: true },
      });
      if (result && result.data) {
        this.estadoSolicitudList.splice(0, this.estadoSolicitudList.length, ...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async firstEstadoSolicitud() {
      this.setPage(1);
      this.emptyList();
      await this.findAllEstadoSolicitudHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.estadoSolicitudList = [];
    },
  },
});
